import { ApplicationsPage } from './ApplicationsPage';

/** Same real data as My Applications, sorted most-recently-deployed first
 * (the table's default sort) — a dedicated deployment-history model doesn't
 * exist yet, and this MVP's real Coolify-backed data is the honest source
 * of truth for "what's deployed" rather than a separate invented dataset. */
export function DeploymentsPage() {
  return <ApplicationsPage title="Deployments" />;
}
